"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var measurement_unit_1 = require("../../shared/models/measurement_unit");
var lodash_find_1 = __importDefault(require("lodash.find"));
exports.shouldShowMM = function (sizingChart, currentVariantId) {
    var relevantMeasurements = sizingChart.measurements;
    if (currentVariantId) {
        relevantMeasurements =
            sizingChart
                .measurements
                .filter(function (m) { return m.variantId === currentVariantId; });
    }
    var sizeChartDisplayUnit = sizingChart.unit;
    var largeMeasurement = 10;
    var allLengths = relevantMeasurements.map(function (obj) {
        var conversionMultiplier = 1;
        if (sizeChartDisplayUnit === measurement_unit_1.imperial) {
            conversionMultiplier = 2.54;
        }
        var startLengthCm = obj.startLength * conversionMultiplier;
        var endLengthCm = obj.endLength === undefined ?
            0
            : obj.endLength * conversionMultiplier;
        return { startLength: startLengthCm, endLength: endLengthCm };
    });
    var hasLargeMeasurement = lodash_find_1.default(allLengths, function (el) {
        return (el.startLength >= largeMeasurement
            || el.endLength >= largeMeasurement);
    });
    return !!hasLargeMeasurement;
};
